import React from 'react'

const Rainbow = (WrappedComponent) => {

    const color = ['red', 'yellow', 'black', 'blue', 'orange', 'green', 'pink'];
    const randoColor = color[Math.floor(Math.random() * 7)];
    const className = randoColor + '-text';
    
    return (props) => {
        return(
        
        <div className={className}>
            <WrappedComponent {...props} />
        </div>)

        
    }
}

export default Rainbow